import React from "react";
import PropTypes from "prop-types";

const AuthContext = React.createContext(null);

const defaultUser = {
  token: "dummy-token",
  name: "Default User",
  email: "user@example.com"
};

export const AuthProvider = ({ userData, children }) => {
  const [user, setUser] = React.useState(userData || defaultUser);
  
  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  userData: PropTypes.any,
  children: PropTypes.any,
};

export const useAuth = () => React.useContext(AuthContext);
